import { Storage } from "aws-amplify";

export const makeBucketName = (dirName, filename) => {
  return `${dirName}/${filename}`;
};

export const deletePublicImage = (key) => {
  Storage.vault.remove(`resized/${key}`, { level: 'public' }).catch(
    e => {
      console.log(e);
    }
  );
};